import { createActions } from './api'

const channels = createActions('channels')

export const fetchChannels = () =>
  channels.get({
    cached: true
  })
